<div class = "giveback-page ">
    <nav class="navbar navbar-expand-md navbar-dark bg-dark">
      <div class="sectpad container-fluid">
        <!-- <a class="navbar-brand logomain" href="javascript:void(0)"><img src="assets/images/logo.png" width="" class="logo"><img
            src="assets/images/logo-mbl.png" width="150" class="logo1"></a> -->
        <a class="navbar-brand logomain getlogo" href="javascript:void(0)" routerLink="/">
          <img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569491458/Static%20images/Logo/honest-gorilla_hduqh0.svg" height="60" class="logo logohead drag-drop" alt="Honest Gorilla">
          <img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569491925/Static%20images/Logo/logotxt_wfug7a.svg" class="logo1 mt-2"></a>
        <button (click)="addClass($event)" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault"
          aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
          <img src="assets/images/list.png" width="18" id="menuIcon" class="listicn">
        </button>
        <div class="collapse navbar-collapse" id="navbarsExampleDefault">
          <ul class="navbar-nav ml-auto webnav">
            <!-- <li class="nav-item active">
              <a class="nav-link" href="javascript:void(0)" routerLink="/about">ABOUT</a>
            </li> -->
            <li class="nav-item active">
              <a class="nav-link font16 semi-bold" href="javascript:void(0)" routerLink="/">RESIDENTIAL</a>
            </li>
            <li class="nav-item active">
              <a class="nav-link font16 semi-bold" href="javascript:void(0)" routerLink="/giveback">GIVEBACK</a>
            </li>
            <li class="nav-item active">
              <a class="nav-link font16 semi-bold" href="javascript:void(0)"  routerLink="/faq">FAQ</a>
            </li>
            <li class="nav-item active">
              <a class="nav-link" href="javascript:void(0)" routerLink="/faq/contact-us">CONTACT US</a>
            </li>
           
           
          </ul>
          <div class="mobilenav">
            <!-- <div class="col-12 row m-0">
              <div class="col-6 col-md mt-3 mb-2  pl-0">
                <a class="btn btn-outline-primary loginmobile w-100" href="javascript:void(0)" routerLink="/login">LOGIN</a>
              </div>
              <div class="col-6 col-md mt-3 mb-2  pr-0 ">
                <a href="javascript:void(0)" class="btnsec w-100" routerLink="/getstarted">GET STARTED</a>
              </div>
            </div> -->
            <div class="col-12 row m-0 p-0">
              <div class="col-6 col-md mb-2 mt-2">
                <h5 class="font16 semi-bold" routerLink="/">COMMERCIAL</h5>
              </div>
              <!-- <div class="col-6 col-md mb-2 mt-2">
                <h5 class="font16 semi-bold" routerLink="/about">About</h5>
              </div> -->
            </div>
            <div class="col-12 row m-0 p-0">
              <div class="col-6 col-md mb-2 mt-2">
                <h5 class="font16 semi-bold" routerLink="/faq">FAQ</h5>
              </div>
              <div class="col-6 col-md mb-2 mt-2">
                <h5 class="font16 semi-bold" routerLink="/giveback">Giveback</h5>
              </div>
              <div class="col-6 col-md mb-2 mt-2">
                <h5 class="font16 semi-bold" routerLink="/faq/contact-us">Contact us</h5>
              </div>
            </div>
          </div>
        </div>
        <a class="btn btn-wp-primary  mr-2 ml-2 login" href="javascript:void(0)" *ngIf= "showLogin" routerLink="/login">LOGIN</a>
        <a class="btn btn-wp-primary  mr-2 ml-2 login" href="javascript:void(0)" *ngIf= "!showLogin" routerLink="/login">LOGOUT</a>
        <a class="btn btn-pw-primary getstart" href="javascript:void(0)" routerLink="/get-started">GET STARTED</a>
      </div>
    </nav>
    </div>